import { render, staticRenderFns } from "./JobableClaimReference.vue?vue&type=template&id=0999f32d"
import script from "./JobableClaimReference.vue?vue&type=script&lang=js"
export * from "./JobableClaimReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports